<template>
  <div id="inspur-container"></div>
</template>

<script>
import Inspur from '@/assets/inspur.dtcity.min.js'
import PubSub from 'pubsub-js'

export default {
  data () {
    return {
      markerId: null,
      positionObj: null
    }
  },
  mounted () {
    this.initMap()
  },
  methods: {
    async initMap () {
      const inspur = await Inspur.build('inspur-OdwS0M+ZF/UBlkCbEuQ1Mw==')
      this.$store.state.inspurMap = inspur
      const bpsOptions = {
        // 设置平台
        platform: 'ps', // 自研平台（默认，为空时默认为自研）
        server: 'proxy', // 场景服务器地址
        app: {
          // 应用id
          appId: '1557972239946674177',
          // 获取新流路的服务
          appServer: 'http://172.17.10.103:8901/prod-api/proxy/cloud',
          // 应用的授权码
          appExpiration: 'eyJhbGciOiJIUzI1NiIsInppcCI6IkRFRiJ9.eNoUyFEKgCAQBcC77Lfg6rr70NtEBQWBEgZGdPdoPuehNvWNCvl21nH7-ajX4oMqMmKUnJMZUgDI0ToalWAQRVJmR_vU_zBhETC_HwAAAP__.sh3mpsAP98erP1pMMaZjpDC5u35FnJfbk5a1Sf5VP-k'
        }
      }
      // const inspur = await Inspur.build('inspur-OdwS0M+ZF/UBlkCbEuQ1Mw==')
      // this.$store.state.inspurMap = inspur
      // // 设置参数（完整参数）
      // const options = {
      //   platform: 'ps', // [必需] 平台：可选ps-自研，dlc-点量，pxy-平行云
      //   server: '172.17.90.101:88', // [必需] 服务地址
      //   app: { // [可选] 点量平台必需，自研平台非必需
      //     appServer: '172.17.90.101:88', // [待定] 获取新流路的服务
      //     appId: '8f8a289a', // [待定] 应用id
      //     appExpiration: 1 // [待定] 该流路有效期
      //   },
      //   openCutscenes: true, // [非必需] 是否自动播放入场动画
      //   netStats: false, // [非必需] 是否启用网络信息
      //   fullscreen: true, // [非必需] 是否启用全屏按钮
      //   keyboardEvents: true, // [非必需] 是否启用键盘输入到后台
      //   // 当keyboardEvents为true时，可以设置忽略键，默认如下
      //   // 按键名称，参考 https://note.youdao.com/s/UvkGNv1 中的“按键”字段
      //   keyboardIgnoreList: ['F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9', 'F10', 'F11', 'F12', 'Tab', '`']
      // }

      // 初始化场景
      // const scene = new inspur.Scene('inspur-container', options)
      const scene = new inspur.Scene('inspur-container', bpsOptions)
      // 等待场景响应好
      const readyStat = await scene.ready()
      if (readyStat.code !== 200) throw readyStat.message

      // 添加地图监听事件
      const event = new inspur.Event()
      event.addCustomListener('screenposition', (response) => {
        console.log('屏幕事件: ' + response)
        console.log('自定义事件: ' + JSON.stringify(response))
        console.log('自定义事件: ' + response.data)
        this.positionObj = response.data
        this.addTipView()
      })
      event.addCustomListener('marker_click', (response) => {
        console.log('标注事件: ' + response)
        console.log('自定义事件: ' + JSON.stringify(response))
        console.log('自定义事件: ' + response.data.id)
        this.markerId = response.data.id
        this.addTipView()
      })
      // 热力图点击事件 wiget-water&elect
      event.addCustomListener('water&elect', (response) => {
        console.log('热力图点击事件: ' + response)
        console.log('热力图点击事件: ' + JSON.stringify(response))
        console.log('热力图点击事件: ' + response.data.id)
        PubSub.publish('we', response.data.id)
      })
      // 实例化
      const markerInstance = new inspur.Marker()
      // 先清空
      await markerInstance.clear()
      // 清空热力图
      const analyze = new inspur.Analyze()
      analyze.close2Dheatmap()
      analyze.closeAlarm()
    },
    addTipView () {
      if (this.markerId && this.positionObj) {
        console.log('发布订阅')
        const data = {
          id: this.markerId,
          x: this.positionObj.x,
          y: this.positionObj.y
        }
        PubSub.publish('addTipView', data)
      }
    }
  }
}
</script>

<style scoped>
#inspur-container {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
</style>
